/**
 * env.js 为默认的env配置， 其它env.xxx.js 对env.js进行扩展。
 * */
export default {
  env: 'production', // 默认线上配置
  FLEET_API_URL: 'https://gasweb-us.99app.com',
  PUBLIC_URL:
    'https://s3-us01.didiglobal.com/ibt-mobility-fe-static/driver-lab/driver-service-backend'
};
